import { CourseLineSubCategory } from '@/models/CourseLine';
import { History } from './History';

export enum PromptCategoryEnum {
  QUIZ = 'QUIZ',
  CODE = 'CODE',
  TRUE_OR_FALSE = 'TRUE_OR_FALSE',
  CODE_FIX = 'CODE_FIX',
  COMPLETE_ACTIVITY = 'COMPLETE_ACTIVITY',
  LESSON_BLOCK = 'LESSON_BLOCK',
  LESSON_MATRIX = 'LESSON_MATRIX',
  OBJECTIVE = 'OBJECTIVE',
  IMAGE_GENERATION = 'IMAGE_GENERATION',
  COURSE_CREATION = 'COURSE_CREATION',
  SLIDE_MATERIAL = 'SLIDE_MATERIAL',
  ACTIVITY_CREATION = 'ACTIVITY_CREATION',
  LESSON_CONTENT = 'LESSON_CONTENT',
}

export interface PromptFile {
  id: number;
  file: string;
  fileName: string;
  isActive: boolean;
  userId: number;
  promptInstructionId: number;
  createdAt: string;
  updatedAt: string;
}

export default interface PromptInstruction {
  id: number;
  category: PromptCategoryEnum;
  subcategory?: CourseLineSubCategory;
  instruction: string;
  role: string | null;
  parentPromptId?: number | null;
  createdAt: string;
  updatedAt: string;
  files?: PromptFile[];
}

export type PromptInstructionHistory = History<PromptInstruction>;
